var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{staticClass:"pc-nav-hidden",class:_vm.activeindex != 0?'nav-active':''}),_c('move-nav-bar',{staticClass:"move-nav-hidden"}),_c('top-banner'),_c('company-info'),_c('copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }